import { newApi, oldApi } from './api.instance';
import { objToQuery } from '../../helpers/common';

export class RecommendationsApis {
  public static getRecommendedProperties = async (language?: string) => {
    return newApi({ ssrLocale: language })
      .get('v1/recommendations/properties')
      .then(({ data }) => data);
  };

  public static getRecommendedPropertiesByProperty = async (
    propertyId?: number | number[],
    language?: string
  ) => {
    return newApi({ ssrLocale: language })
      .get(`v1/recommendations/properties/${propertyId}`)
      .then(({ data }) => data);
  };

  public static getRecommendedCompounds = async (
    id: number,
    language?: string
  ) => {
    const query = { ...(language && { language }) };
    //   return newApi({ ssrLocale: language })
    //     .get(`v1/recommendations/compounds/${id}`)
    //     .then(({ data }) => data);
    return oldApi()
      .get(`/compounds/${id}/get_recommendations?${objToQuery(query)}`)
      .then(({ data }) => data);
  };
}
